import type { ApiObject } from "@rudderstack/analytics-js";
import { RudderAnalytics } from "@rudderstack/analytics-js";
import { getFeatureFlag, isString, isValidUrl } from "@sinch/feature-flags";

const rudderanalytics = new RudderAnalytics();

export const initRudderstack = (startSession = false) => {
  const dataPlaneUrl = getFeatureFlag(
    "rudderstackDataPlaneUrl",
    isValidUrl,
    "https://mailgun-dataplane.rudderstack.com"
  );
  const writeKey = getFeatureFlag("rudderstackKey", isString, "");
  if (!writeKey || !dataPlaneUrl) {
    console.error("Couldn't find a rudderstack Key or Url");
    return Promise.resolve();
  }
  rudderanalytics.load(writeKey, dataPlaneUrl, {
    storage: { type: "localStorage" }, // Avoid sending cookies to the server all the time.
    sessions: { autoTrack: startSession },
  });
  return Promise.resolve();
};

export const startRudderstackSession = (userId?: string) => {
  try {
    rudderanalytics.startSession();
    rudderanalytics.identify(userId);
  } catch (e) {
    console.error(e);
  }

  return rudderanalytics.endSession;
};

export const trackRudderStackEvent = (eventId: string, properties: ApiObject) =>
  rudderanalytics.track(eventId, properties, {
    integrations: {
      All: true,
      SNOWFLAKE: {
        // Use SNOWFLAKE for Snowflake, RS for Redshift, BQ for BigQuery, POSTGRES for PostgreSQL.
        options: {
          // This doesn't seem to work, but we have a transofrmation on rudderstack doing the same and that seemed to work
          jsonPaths: ["track.properties.CUSTOM", "track.properties.custom"],
        },
      },
    },
  });

export const getRudderStackAnonymousId = () => rudderanalytics.getAnonymousId();
